"use client";
import { jsx } from "react/jsx-runtime";
import { useImageConfig } from "../../utils/ImageConfigProvider/ImageConfigProviderClient.js";
import { getSwappedImageDomainUrl } from "../../utils/images/lib.js";
import { Image } from "@nxt-costco-com/forge-components";
const GenericImageHandler = ({
  src,
  ...props
}) => {
  const { imageDomainSwapConfig } = useImageConfig();
  if (!src) return null;
  return /* @__PURE__ */ jsx(
    Image,
    {
      src: getSwappedImageDomainUrl(src, imageDomainSwapConfig),
      ...props
    }
  );
};
GenericImageHandler.displayName = "GenericImageHandler";
export {
  GenericImageHandler as default
};
